import { render, staticRenderFns } from "./DesksPage.vue?vue&type=template&id=e7563512&scoped=true"
import script from "./DesksPage.vue?vue&type=script&lang=js"
export * from "./DesksPage.vue?vue&type=script&lang=js"
import style0 from "./DesksPage.vue?vue&type=style&index=0&id=e7563512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7563512",
  null
  
)

export default component.exports